import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
  {
    path: '/',
    redirect: '/payInit',
  },
  {
    path: '/payInit',
    name: 'payInit',
    component: () => import('./view/payment/payInit'),
    meta: {
      title: '支付授权',
    },
  },
  {
    path: '/orderDetailPay',
    name: 'orderDetailPay',
    component: () => import('./view/payment/orderDetailPay'),
    meta: {
      title: '求付款',
    },
  },
  {
    path: '/errorTips',
    name: 'errorTips',
    component: () => import('./view/payment/errorTips'),
    meta: {
      title: '页面异常',
    },
  },
  {
    path: '/paySuccess',
    name: 'paySuccess',
    component: () => import('./view/payment/paySuccess'),
    meta: {
      title: '支付成功',
    },
  },
  {
    path: '/linkToMiniApp',
    name: 'linkToMiniApp',
    component: () => import('./view/linkToMiniApp/index'),
    meta: {
      title: '正在跳转',
    },
  },
];

// add route path
routes.forEach((route) => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new Router({
  mode: 'history',
  routes,
});

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export { router };
